export function formatPrice(cents, currency = "chf") {
  const amount = (cents / 100).toFixed(2).replace(/\.00$/, ".–");
  return `${currency.toUpperCase()} ${amount}`;
}
